<script>
import StatusAwareAtom from "../StatusAwareComponent.vue";

export default {
  name: "ClockActionLabel",
  extends: StatusAwareAtom,
  computed: {
    text() {
      return this.status === this.statuses.working
          ? trans('general.component.attendance_clock_widget.clock_out')
          : trans('general.component.attendance_clock_widget.clock_in');
    },
  }
}
</script>

<template>
  <div>
    <p class="text-center large label button-label mb-0">{{ text }}</p>
  </div>
</template>
